export default {
  getCurrencies(state) {
    return state.currencies;
  },
};
